import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import styles from './OrderDetail.module.scss';
import leftArrow from '../../assets/leftArrow02.png';
import imsiProduct from '../../assets/imsi/imsiProduct4.png';
import discountListMark from '../../assets/discountListMark.png';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { IOrderDataType } from '../OrderComplete/OrderComplete';
import LoginHandler from '../../components/LoginHandler/LoginHandler';
import { useTranslation } from 'react-i18next';

function OrderDetail() {
  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState<IOrderDataType[]>();
  const [productIdList, setProductIdList] = useState<number[]>([]);

  useEffect(() => {
    axiosClient.get(`/data/order?order_id=${orderNumber}`).then((res) => {
      if (!res.data.data.length) {
        alert(t('orderComplete.23'));
        navigate('/');
      }
      setOrderData(res.data.data);
    });
  }, []);
  useEffect(() => {
    if (!orderData) return;
    let list: number[] = [];
    orderData[0]?.products?.map((product) => {
      if (!list.includes(product.product_id)) list.push(product.product_id);
    });
    setProductIdList(list);
  }, [orderData]);
  function handleOrderCancel() {
    let confirm = window.confirm(t('other.52')!);
    if (!confirm) return;
    axiosClient
      .get(`/func/order/order_cancel?order_id=${orderNumber}`)
      .then((res) => window.location.reload())
      .catch((err) => alert(t('other.51')));
  }
  function deliveryCheck() {
    if (!orderData) return;
    window.open(
      `/deliveryDetail/${orderData[0].products[0].send_company}/${orderData[0].products[0].send_number}`,
      '',
      'width=500,height=700',
    );
  }
  const { t, i18n } = useTranslation();
  return (
    <div className={styles.container}>
      <LoginHandler />
      <Header />
      <div className={styles.header} onClick={() => navigate(-1)}>
        <img src={leftArrow} alt="arrow" />
        <span>{t('orderDetail.15')}</span>
      </div>
      <div className={styles.orderInfoWrap}>
        <div className={styles.orderHeader}>
          <span>
            {orderData &&
              (() => {
                let list = orderData[0]?.order_date
                  .substring(0, 10)
                  .replace(/-/gi, '.');
                return list;
              })()}{' '}
            Payment
          </span>
          <span>{orderData && orderData[0]?.order_id}</span>
        </div>
        {orderData &&
          productIdList.map((id) => {
            let optionList: string[] = [];
            let count = 0;
            let productImage = '';
            let productName = '';
            let orderSendNumber = '';
            let sendCompany = '';
            orderData[0]?.products
              .filter((product) => product.product_id == id)
              .map((product) => {
                optionList.push(product.option);
                count += product.count;
                productImage = product.image;
                productName = product.title;
                orderSendNumber = product.send_number || 'None';
                sendCompany = product.send_company || '';
              });
            return (
              <div className={styles.orderProductInfoWrap} key={id}>
                <div className={styles.sectionHeader}>
                  <span>{t('orderDetail.1')}</span>
                  {(orderData[0].pay_status == '배송대기' ||
                    orderData[0].pay_status == '결제완료') && (
                    <div
                      className={styles.orderCancelBtn}
                      onClick={handleOrderCancel}
                    >
                      {t('orderDetail.20')}
                    </div>
                  )}
                  {/* {!(
                    orderData[0].pay_status == '결제대기' ||
                    orderData[0].pay_status == '배송대기' ||
                    orderData[0].pay_status == '결제완료'
                  ) &&
                    orderData[0].products[0].send_number && (
                      <div
                        className={styles.deliveryCheck}
                        onClick={deliveryCheck}
                      >
                        배송조회
                      </div>
                    )} */}
                  <div
                    className={styles.status}
                    style={{
                      borderColor:
                        orderData[0].pay_status == '결제대기' ||
                        orderData[0].pay_status == '결제완료' ||
                        orderData[0].pay_status == '배송대기'
                          ? '#F6F7F9'
                          : orderData[0].pay_status == '배송준비'
                          ? 'rgba(30, 166, 28, 0.18)'
                          : orderData[0].pay_status == '배송중'
                          ? '#B7E7BD'
                          : orderData[0].pay_status == '배송완료'
                          ? '#121842'
                          : orderData[0].pay_status == '주문취소'
                          ? '#DC0000'
                          : '',
                      color:
                        orderData[0].pay_status == '결제대기' ||
                        orderData[0].pay_status == '결제완료' ||
                        orderData[0].pay_status == '배송대기'
                          ? '#999999'
                          : orderData[0].pay_status == '배송준비'
                          ? '#00BE35'
                          : orderData[0].pay_status == '배송중'
                          ? '#00BE35'
                          : orderData[0].pay_status == '배송완료'
                          ? '#141736'
                          : orderData[0].pay_status == '주문취소'
                          ? '#DC0000'
                          : '',
                      backgroundColor:
                        orderData[0].pay_status == '결제대기' ||
                        orderData[0].pay_status == '결제완료' ||
                        orderData[0].pay_status == '배송대기'
                          ? '#F6F7F9'
                          : 'white',
                    }}
                  >
                    {orderData[0].pay_status == '결제대기'
                      ? t('myPage.7')
                      : orderData[0].pay_status == '결제완료' ||
                        orderData[0].pay_status == '배송대기'
                      ? t('myPage.8')
                      : orderData[0].pay_status == '배송준비'
                      ? t('myPage.9')
                      : orderData[0].pay_status == '배송중'
                      ? t('myPage.10')
                      : orderData[0].pay_status == '배송완료'
                      ? t('myPage.11')
                      : orderData[0].pay_status == '주문취소'
                      ? t('myPage.13')
                      : ''}
                  </div>
                </div>
                <div className={styles.productWrap}>
                  <div className={styles.thumbnailWrap}>
                    <img src={productImage} alt="thumbnail" />
                  </div>
                  <div className={styles.right}>
                    <span className={styles.productName}>{productName}</span>
                    <div className={styles.option}>
                      <span>{t('orderDetail.16')}</span>
                      <ul>
                        {optionList.map((option) => (
                          <li key={option}>{option}</li>
                        ))}
                      </ul>
                    </div>
                    <div className={styles.count}>
                      <span>{t('orderDetail.2')}</span>
                      <span>{count}</span>
                    </div>
                  </div>
                </div>
                <div className={styles.deliveryNumber}>
                  <span>{t('orderDetail.3')}</span>
                  <span>
                    {orderSendNumber}
                    {sendCompany && <> ({sendCompany})</>}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
      {/* <div className={styles.refundWrap}>
        <div className={styles.refundHeader}>교환/반품/환불 사유</div>
        <p>제품 하자로 인한 환불</p>
      </div> */}
      <div className={styles.addressInfoWrap}>
        <div className={styles.addressHeader}>{t('orderDetail.4')}</div>
        <div className={styles.addressInfo}>
          <div className={styles.half}>
            <span>{t('orderDetail.5')}</span>
            <span>{orderData && orderData[0]?.receive_name}</span>
          </div>
          <div className={styles.half}>
            <span>{t('orderDetail.6')}</span>
            <span>{orderData && orderData[0]?.receive_phone}</span>
          </div>
          <div>
            <span>{t('orderDetail.7')}</span>
            <span>
              {orderData && orderData[0]?.receive_address}{' '}
              {orderData && orderData[0]?.receive_state}
            </span>
          </div>
          <div>
            <span>{t('orderDetail.8')}</span>
            <span>{orderData && orderData[0]?.request_memo}</span>
          </div>
        </div>
      </div>
      <div className={styles.payInfoWrap}>
        <div className={styles.payHeader}>{t('orderDetail.9')}</div>
        <div className={styles.priceCalculation}>
          <div>
            <span>{t('orderDetail.10')}</span>
            <span>${orderData && orderData[0]?.price.toLocaleString()}</span>
          </div>
          <div>
            <span>{t('orderDetail.11')}</span>
            <span>
              ${orderData && orderData[0]?.delivery_price.toLocaleString()}
            </span>
          </div>
          <div>
            <span>{t('orderDetail.12')}</span>
            <span>
              -$
              {orderData &&
                (
                  orderData[0]?.use_coupon +
                  orderData[0]?.use_point +
                  orderData[0]?.use_promotion
                ).toLocaleString()}
            </span>
          </div>
          <ul className={styles.discountInfoList}>
            {orderData && orderData[0]?.use_coupon > 0 && (
              <li>
                <div>
                  <img src={discountListMark} alt="discountListMark" />
                  <span>{t('orderDetail.21')}</span>
                </div>
                <span>-${orderData[0]?.use_coupon.toLocaleString()}</span>
              </li>
            )}
            {orderData && orderData[0]?.use_promotion > 0 && (
              <li>
                <div>
                  <img src={discountListMark} alt="discountListMark" />
                  <span>{t('orderDetail.22')}</span>
                </div>
                <span>-${orderData[0]?.use_promotion.toLocaleString()}</span>
              </li>
            )}{' '}
            {orderData && orderData[0]?.use_point > 0 && (
              <li>
                <div>
                  <img src={discountListMark} alt="discountListMark" />
                  <span>{t('orderDetail.23')}</span>
                </div>
                <span>-${orderData[0].use_point.toLocaleString()}</span>
              </li>
            )}
          </ul>
        </div>
        <div className={styles.totalPrice}>
          <div>
            <span>{t('orderDetail.13')}</span>
            <span>
              ${orderData && orderData[0]?.total_price.toLocaleString()}
            </span>
          </div>
          <span>{t('orderDetail.17')}</span>
        </div>
      </div>
      <div className={styles.payMethodWrap}>
        <div className={styles.payMethodHeader}>{t('orderDetail.14')}</div>
        {orderData && orderData[0]?.card_info.card_name && (
          <span>
            {t('orderDetail.19')} (
            {orderData && orderData[0]?.card_info.card_name}/
            {orderData &&
              (orderData[0]?.card_info.card_quota == '00'
                ? 'lump sum'
                : `${orderData[0]?.card_info.card_quota}monthly installment`)}
            )
          </span>
        )}
        {/* <span>paypal</span> */}
        {/* {orderData && orderData[0].bank_account && (
          <>
            <span>무통장입금</span>
            <span>{orderData[0].bank_account}</span>
          </>
        )} */}
      </div>
      <div className={styles.refundGuide}>
        <span>{t('orderDetail.18')}</span>
      </div>
      <Footer />
    </div>
  );
}
export default OrderDetail;
